import { CoreAnalysisEngine, AnalysisResult } from "./coreAnalysisEngine";
import { ReactElement } from "react";
import { TFunction } from "i18next";
import { AnalysisEngineType, EngineType } from "../types";
import { ResultCo2Demo } from "../components/molecules/ResultCo2Demo";
import { ResultCo2TFH } from "../components/molecules/ResultCo2TFH";

export type Co2AnalysisResult = AnalysisResult<"co2">;
export type Co2DetailedAnalysisResult = {
  sub_scores: {
    sub_score_ah: number | "NaN";
    sub_score_eh: number | "NaN";
    sub_score_uh: number | "NaN";
  };
  details: Record<string, number>;
};

interface EngineProps {
  _analysisType?: AnalysisEngineType | null;
}

export class Co2Engine extends CoreAnalysisEngine<"co2"> {
  _engineType: EngineType = "co2";
  _analysisType: AnalysisEngineType | null = null;

  constructor(props?: EngineProps) {
    super("co2");
    if (props && props._analysisType) {
      this._analysisType = props._analysisType;
    }
  }

  async renderResult(
    key: number,
    fileId: string,
    t: TFunction,
  ): Promise<ReactElement> {
    const result = await this.getResult(fileId);
    if (!result) {
      // TODO: getResult失敗時のフォールバックUIを用意する
      return <></>;
    }

    const getValue = (
      value: number | "NaN" | undefined,
      nanvalue: number | undefined = undefined,
    ): number | undefined => {
      return value === "NaN" ? nanvalue : value;
    };

    const pre_cog_score = result.analysis_result.pre_cog_score;
    const co2_result = result.analysis_result.co2_result;
    const detailed = result.detailed_analysis_result as
      Co2DetailedAnalysisResult | undefined;
    const pre_cog_subscore_ah = getValue(detailed?.sub_scores.sub_score_ah);
    const pre_cog_subscore_eh = getValue(detailed?.sub_scores.sub_score_eh);
    const pre_cog_subscore_uh = getValue(detailed?.sub_scores.sub_score_uh);

    return this._analysisType === "TFH" ? (
      <ResultCo2TFH
        key={key}
        title={t("Result.Dementia_analysis_result")}
        pre_cog_score={pre_cog_score}
        co2_result={co2_result}
        pre_cog_subscore_ah={pre_cog_subscore_ah}
        pre_cog_subscore_eh={pre_cog_subscore_eh}
        pre_cog_subscore_uh={pre_cog_subscore_uh}
      />
    ) : (
      <ResultCo2Demo
        key={key}
        title={t("Result.Dementia_analysis_result")}
        pre_cog_score={pre_cog_score}
        co2_result={co2_result}
        pre_cog_subscore_ah={pre_cog_subscore_ah}
        pre_cog_subscore_eh={pre_cog_subscore_eh}
        pre_cog_subscore_uh={pre_cog_subscore_uh}
      />
    );
  }
}
